module.exports = __webpack_public_path__ + "img/组 12.8b2975cd.png";